import { OfferFragment } from '@occc/graphql';

export type OfferFulfillmentPriorityInitialValues = {
  fulfillmentPriorityLevel?: number;
};

// Read mapping for Offer Fulfillment Priority (OCST-28864). Shared across all in-scope
// campaign components; called from each component's initial-values transform.
export const getOfferFulfillmentPriorityInitialValues = (
  offer?: OfferFragment,
): OfferFulfillmentPriorityInitialValues => ({
  fulfillmentPriorityLevel: offer?.fulfillmentPriorityLevel ?? undefined,
});
